import '../sass/testimonials.scss';

const noMotionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');

(() => {
    const swiperScript = document.querySelector('#boomspace-theme-swiper-js');
    const $blocks = document.querySelectorAll('.testimonials');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $slider = $block.querySelector('.testimonials__carousel');

        const initCarousel = () => {
            if (!$slider) return;

            new Swiper($slider, {
                loop: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                },
                autoplay: true,
                pagination: {
                    el: '.testimonials__pagination',
                    type: 'bullets',
                    clickable: true,
                },
                speed: noMotionPreference.matches ? 300 : 0,
            });
        };

        if (typeof Swiper !== 'undefined') { 
            initCarousel();
        } else {
            swiperScript.addEventListener('load', () => {
                initCarousel();
            });
        }
    });
})();
